import ExcelJS from "exceljs";
import { DateTime } from "luxon";

export async function exportVuetifyToExcel(headers, items, options = {}) {
  const {
    title = "Reporte",
    subtitle = "",
    filename = "reporte",
    color = "1F4E78",
    minWidth = 5,
    maxWidth = 100,
  } = options;

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Datos");

  const totalCols = headers.length;
  let currentRow = 1;

  // 🟦 Título
  sheet.mergeCells(currentRow, 1, currentRow, totalCols);
  const titleCell = sheet.getCell(currentRow, 1);
  titleCell.value = title;
  titleCell.alignment = { horizontal: "center", vertical: "middle" };
  titleCell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 16 };
  titleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: color } };
  currentRow++;

  // 🟦 Subtítulo
  if (subtitle) {
    sheet.mergeCells(currentRow, 1, currentRow, totalCols);
    const subtitleCell = sheet.getCell(currentRow, 1);
    subtitleCell.value = subtitle;
    subtitleCell.alignment = { horizontal: "center", vertical: "middle" };
    subtitleCell.font = { bold: false, color: { argb: "FF000000" }, size: 12 };
    subtitleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFFFF" } };
    currentRow++;
  }

  // 🟦 Encabezados
  const headerRow = sheet.addRow(headers.map(h => h.text));
  headerRow.eachCell(cell => {
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: color } };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // 🟦 Filas de datos
  items.forEach(item => {
    const rowData = headers.map(h => {
      let val = item[h.value];

      if (val === null || val === undefined) return "";

      if (typeof val === "string" && /^\d{4}-\d{2}-\d{2}T/.test(val)) {
        const dt = DateTime.fromISO(val);
        if (dt.isValid) {
          if (dt.hour || dt.minute || dt.second) {
            return dt.toFormat("dd/LL/yyyy HH:mm");
          }
          return dt.toFormat("dd/LL/yyyy");
        }
      }

      return val;
    });

    const row = sheet.addRow(rowData);
    row.eachCell(cell => {
      cell.font = { color: { argb: "FF000000" } };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFFFF" } };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // 🟦 Autoajuste dinámico de columnas (con ajuste de factor)
  const columnWidths = new Array(headers.length).fill(minWidth);

  // Revisar encabezados
  headers.forEach((header, i) => {
    const headerLength = header.text ? header.text.toString().length * 1.2 : 0;
    columnWidths[i] = Math.max(columnWidths[i], Math.ceil(headerLength));
  });

  // Revisar datos
  items.forEach(item => {
    headers.forEach((header, i) => {
      let val = item[header.value];

      if (val === null || val === undefined) {
        val = "";
      } else if (typeof val === "string" && /^\d{4}-\d{2}-\d{2}T/.test(val)) {
        const dt = DateTime.fromISO(val);
        if (dt.isValid) {
          if (dt.hour || dt.minute || dt.second) {
            val = dt.toFormat("dd/LL/yyyy HH:mm");
          } else {
            val = dt.toFormat("dd/LL/yyyy");
          }
        }
      }

      const len = val.toString().length * 1.2; // ✅ ajuste proporcional
      columnWidths[i] = Math.max(columnWidths[i], Math.ceil(len));
    });
  });

  // Aplicar anchos finales
  columnWidths.forEach((w, i) => {
    sheet.getColumn(i + 1).width = Math.min(Math.max(w + 2, minWidth), maxWidth);
  });

  // 🟦 Exportar
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/octet-stream" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.xlsx`;
  a.click();
  window.URL.revokeObjectURL(url);
}